import React from "react";
import MaterialTable from "material-table";
import { Api } from "../../utils/api";

export default class EntityUsersTable extends React.Component {
  state = {
    columns: [
      { title: "", field: "id", hidden: true },
      { title: "", field: "entity_id", hidden: true },
      { title: "", field: "user_entity_id", hidden: true },
      { title: "Nome", field: "name" },
      { title: "Email", field: "email" },
      {
        title: "Administrador",
        field: "is_admin",
        type: "boolean",
        render: (rowData) => {
          return rowData.is_admin ? "Sim" : "Não";
        },
      },
      {
        title: "Recebe faturação",
        field: "receive_billing_info",
        type: "boolean",
        render: (rowData) => {
          return rowData.receive_billing_info ? "Sim" : "Não";
        },
      },
    ],
  };

  constructor() {
    super();
    this.api = new Api();
    this.goTo = this.goTo.bind(this);
    this.refreshPage = this.refreshPage.bind(this);
  }

  goTo(location, params) {
    this.props.history.push(location, params);
  }

  refreshPage() {
    window.location.reload();
  }

  render() {
    const { users } = this.props;
    const onAdd = this.props.handleAdd;
    const onUpdate = this.props.handleUpdate;
    const onDelete = this.props.handleDelete;

    return (
      <MaterialTable
        title=""
        columns={this.state.columns}
        data={users}
        options={{ rowStyle: { backgroundColor: "#EEE" } }}
        editable={{
          onRowAdd: (newData) => {
            newData.entity_id = this.props.entity_id;
            onAdd(newData).then(() => {
              this.refreshPage();
            });
          },
          onRowUpdate: (newData, oldData) => {
            newData.entity_id = this.props.entity_id;
            onUpdate(newData).then(() => {
              this.refreshPage();
            });
          },
          onRowDelete: (oldData) => {
            oldData.entity_id = this.props.entity_id;
            onDelete(oldData).then(() => {
              this.refreshPage();
            });
          },
        }}
      />
    );
  }
}
